var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36.5,
    r: 36.5,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3652 22.2734H26.3095C25.1683 22.2734 24.1766 23.0575 23.9133 24.1678C23.1597 27.3454 22.5834 31.9971 25.8006 32.558C25.9654 32.5867 26.1377 32.602 26.3177 32.602C28.2988 32.602 29.3853 30.7507 29.8018 29.4832C29.8361 29.3789 30.0255 29.3823 30.0573 29.4874C30.4174 30.6776 31.4454 32.3853 33.5588 32.3853C35.7271 32.3853 36.6761 30.5879 36.9595 29.3958C36.9838 29.2937 37.1474 29.2765 37.1906 29.3721C37.7289 30.5639 39.0015 32.3853 40.8723 32.3853C42.7819 32.3853 43.7443 30.4878 44.0599 29.299C44.085 29.2045 44.2228 29.1887 44.2666 29.2761C44.8811 30.502 46.3554 32.6729 48.2583 32.3853C48.2962 32.3796 48.3336 32.3734 48.3704 32.3669C51.5721 31.7994 50.6841 27.0393 49.6744 23.9484C49.348 22.9493 48.4162 22.2734 47.3652 22.2734Z",
    stroke: "#AAAAAA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 35.707V48.9247C24.2187 49.5025 25.2325 50.7303 25.8118 50.7303C26.6228 50.7303 41.0182 50.7303 48.1145 50.7303C48.5972 50.4896 49.5627 49.8203 49.5627 49.0691C49.5627 48.3179 49.5627 39.8481 49.5627 35.707",
    stroke: "#AAAAAA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7656 35.707V43.4597C27.7656 43.7986 28.4955 44.5188 28.9126 44.5188C29.4965 44.5188 39.8612 44.5188 44.9705 44.5188C45.3181 44.3776 46.0133 43.985 46.0133 43.5444C46.0133 43.1038 46.0133 38.1359 46.0133 35.707",
    stroke: "#AAAAAA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8555 25.9844H49.7787",
    stroke: "#AAAAAA",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.5a84306e42ddd6c84f5d855a67fd085e.svg";
export { ForwardRef as ReactComponent };